import { Avatar, Grid, makeStyles } from "@material-ui/core";
import React, { createRef, useEffect, useRef, useState } from "react";
import SpIconButton from "../../../components/atoms/SpIconButton";
import SpText from "../../../components/atoms/SpText";
import { labels, psTranslate } from "../../shared/translations";
import { getColorFromPatientStatus, titleCase } from "../../../utils/common";
import moment from "moment";
import momentTimezone from "moment-timezone";
import { SpSelect, SpSelectMenuItem } from "../../../components/atoms/SpSelect";
import {
  getMonitoringData,
  getMonitoringDataPatients,
} from "../../../models/actions/Monitoring";
import { getAllCalendarActivityByMonitGroup } from "../../../models/actions/CalendarActivity";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import dayjs from "dayjs";
import {
  ChangeAvailabilityDialog,
  LegendAvailability,
  LegendStatus,
  SelectPeriod,
} from "./SituationTableHelper";
import { getDateTimeActivityPatient } from "../../../models/actions/Disponibility";
import { useParams } from "react-router-dom";

export const MonitoringTable = ({
  patients,
  setLoading,
  groupId,
  fetchDataSituationTable,
  snackbarShowErrorMessage,
}) => {
  const useStyles = makeStyles((theme) => ({
    root: {
      "&::-webkit-scrollbar": {
        height: 10,
      },
      "&::-webkit-scrollbar-track": {
        background: "#012e29",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#31caad",
      },
    },
  }));
  const { id_group } = useParams();
  const offsetFormatted = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const scrollingDivMonitoring = createRef();
  const scrollingDivAvailability = createRef();
  const classes = useStyles();
  const [filterStartDate, setFilterStartDate] = useState(
    moment().subtract(1, "months")
  );
  const [filterEndDate, setFilterEndDate] = useState(moment());
  const [disponibility, setDisponibility] = useState([]);
  const [groupState, setGroupState] = useState([]);
  const [groupStateFilter, setGroupStateFilter] = useState([]);
  const [openToggleAvailability, setOpenToggleAvailability] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState();
  const [availabilitySelected, setAvailabilitySelected] = useState({
    status: "fit",
    date: moment(),
    patient: "",
  });

  const fetchData = async () => {
    try {
      setLoading(true);
      if (patients) {
        const getActivityDateTimePatient = await getDateTimeActivityPatient({
          id_patients: patients.map(({ id }) => id),
          id_group: groupId,
          start_date: filterStartDate,
          end_date: filterEndDate,
        });

        // togliamo degli id_patient rimasti nel gruppo che sono stati cancellati (attivita' ancora rimaste)
        const activitiesFilter = getActivityDateTimePatient.filter((patient) =>
          patients.some((pat) => pat.id === patient.patient_id)
        );
        setDisponibility(activitiesFilter.map((it) => it.disponibility));

        setGroupState(getActivityDateTimePatient);
        setGroupStateFilter(getActivityDateTimePatient);
      }
      const elMonitoring = document.getElementById("scrollingDivMonitoring");
      if (elMonitoring) elMonitoring.scrollLeft = elMonitoring.scrollWidth;
      const elAvailability = document.getElementById(
        "scrollingDivAvailability"
      );
      if (elAvailability)
        elAvailability.scrollLeft = elAvailability.scrollWidth;
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      snackbarShowErrorMessage(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [filterStartDate, filterEndDate, patients]);

  useEffect(() => {
    if (selectedEvent === null) {
      setGroupState(selectedEvent);
      fetchData();
    } else {
      const activityFilter = groupStateFilter.filter(
        (it) =>
          it.activity_type_name.toLowerCase() === selectedEvent.toLowerCase()
      );
      setGroupState(activityFilter);
    }
  }, [selectedEvent]);

  const renderActivityMonitoring = (currentPatient, id) => {
    return (
      <Grid
        item
        xs={6}
        style={{
          display: "flex",
          "justify-content": "center",
          "align-items": "center",
          minHeight: 40,
          minWidth: 100,
          border: "1px solid #31caad",
          padding: 4,
        }}
      >
        <FiberManualRecordIcon
          style={{
            display: "flex",
            "justify-content": "center",
            "align-items": "center",

            cursor: "default",
            color: getColorFromPatientStatus({
              status: currentPatient.status?.key,
            }),
            marginLeft: "3px",
          }}
        />
      </Grid>
    );
  };

  const renderDateDisponibility = () => {
    return groupState.map((item) => {
      return (
        <Grid
          id={item.start_date}
          item
          style={{
            minHeight: 40,
            minWidth: 80,
            border: "1px solid #31caad",
            padding: 4,
          }}
        >
          <SpText textAlign={"center"} variant="h4ComponentLabel">
            {dayjs(item.start_date).format("DD/MM/YYYY")}
            {" - "}
            {` ${momentTimezone
              .utc(item.start_time, "HH:mm:ss")
              .tz(offsetFormatted)
              .format("HH:mm")} - ${momentTimezone
              .utc(item.end_time, "HH:mm:ss")
              .tz(offsetFormatted)
              .format("HH:mm")}`}
          </SpText>
        </Grid>
      );
    });
  };

  const renderDisponibility = (item, id, givenName, familyName) => {
    const currentPatient = item.patient_state.find(
      (it) => it.patient_id === id
    );

    const disponibilitySelected = currentPatient.disponibility
      ?.patient_disponibility
      ? currentPatient.disponibility.patient_disponibility
      : currentPatient.disponibility;

    return (
      <Grid container>
        <Grid
          item
          xs={6}
          style={{
            display: "flex",
            "justify-content": "center",
            "align-items": "center",
            minHeight: 40,
            minWidth: 100,
            border: "1px solid #31caad",
          }}
        >
          <SpIconButton
            variant="lightBlue"
            onClick={() => {
              setAvailabilitySelected({
                status: currentPatient.disponibility.patient_disponibility
                  ? currentPatient.disponibility.patient_disponibility
                  : currentPatient.disponibility,
                date: moment(item.start_date, "YYYY-MM-DD"),
                patient: `${givenName} ${familyName}`,
                id_patient: currentPatient.patient_id,
                id_activity_groups: item.id_activity_groups,
              });
              setOpenToggleAvailability(true);
            }}
            style={{
              width: "0px !important",

              height: "0px !important",
            }}
          >
            <div
              style={{
                backgroundColor:
                  disponibilitySelected === "fit" ? "green" : "red",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100",
                height: "100",
                borderRadius: "50%",
              }}
            >
              <img
                src={require(`../../../assets/activities/training.png`)}
                alt="Immagine"
                style={{
                  maxWidth: "1em",
                  maxHeight: "1em",
                  margin: "5px",
                  backgroundColor:
                    disponibilitySelected === "fit" ? "green" : "red",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100",
                  height: "100",
                  borderRadius: "50%",
                }}
              />
            </div>
          </SpIconButton>
        </Grid>

        {renderActivityMonitoring(currentPatient, id)}
      </Grid>
    );
  };

  const renderColumnDisponibility = () => {
    return patients?.map(({ id, givenName, familyName }) => (
      <Grid>
        <Grid
          item
          xs={10}
          style={{
            minHeight: 40,
            minWidth: 200,
            border: "1px solid #31caad",
            padding: 4,
          }}
        >
          <SpText variant="h4ComponentLabel">{`${titleCase(
            givenName
          )} ${titleCase(familyName)}`}</SpText>
        </Grid>
        <Grid>
          <Grid container>
            <Grid
              item
              xs
              style={{
                minHeight: 40,
                minWidth: 100,
                border: "1px solid #31caad",
                padding: 4,
              }}
            >
              <SpText variant="h4ComponentLabel">{"Disponibilita"}</SpText>
            </Grid>
            <Grid
              item
              xs
              style={{
                minHeight: 40,
                minWidth: 100,
                border: "1px solid #31caad",
                padding: 4,
              }}
            >
              <SpText variant="h4ComponentLabel">{"Stato Salute"}</SpText>
            </Grid>
          </Grid>

          {groupState.map((item) => {
            return (
              <Grid item xs={12} container direction="column">
                {renderDisponibility(item, id, givenName, familyName)}
              </Grid>
            );
          })}
        </Grid>
      </Grid>
    ));
  };
  return (
    <Grid container direction="column">
      <div style={{ width: "100%" }}>
        <SelectPeriod
          setFilterStartDate={setFilterStartDate}
          filterStartDate={filterStartDate}
          setFilterEndDate={setFilterEndDate}
          filterEndDate={filterEndDate}
        />
      </div>

      {groupState && (
        <div style={{ width: "100%" }}>
          {/* Group availability*/}
          <Grid
            item
            xs={12}
            direction="row"
            container
            style={{ paddingTop: "2em" }}
          >
            <Grid xs={6}>
              <SpText variant={"h1PageTitle"}>
                {labels.patient.monitoring.table.groupAvailability}
              </SpText>
            </Grid>
            <LegendAvailability />
            <LegendStatus />
          </Grid>
          <Grid
            item
            xs={12}
            container
            direction="row"
            style={{ width: "100%", marginBottom: 5 }}
          >
            <Grid item xs={2} container direction="column">
              <Grid
                item
                xs
                style={{
                  maxHeight: 40,
                  border: "1px solid #31caad",
                  padding: 4,
                }}
              ></Grid>

              <Grid
                item
                xs
                style={{
                  maxHeight: 40,
                  minHeight: 40,
                  minWidth: 80,
                  border: "1px solid #31caad",
                }}
              >
                <SpSelect
                  formControlStyle={{
                    width: "100%",
                    height: "100%",

                    padding: 0,
                  }}
                  selectstyle={{
                    borderColor: "transparent",
                    backgroundColor: "",
                    padding: 0,
                    width: "100%",
                    height: "100%",
                    maxHeight: "40px",
                  }}
                  labelPlacementLeft={{
                    width: "100%",
                    height: "100%",
                    maxHeight: "40px",
                  }}
                  displayLabel={true}
                  onChange={(e) => setSelectedEvent(e.target.value)}
                  value={selectedEvent}
                  labelStyle={{ fontSize: "1em" }}
                >
                  <SpSelectMenuItem key={"null-key"} value={null}>
                    {labels.groups.groupReports.firstTable.selectAtivity}
                  </SpSelectMenuItem>
                  <SpSelectMenuItem key={"allenamento"} value={"allenamento"}>
                    {
                      labels.groups.groupReports.firstTable
                        .typeSelectActivity[0]
                    }
                  </SpSelectMenuItem>
                  <SpSelectMenuItem key={"gara"} value={"gara"}>
                    {
                      labels.groups.groupReports.firstTable
                        .typeSelectActivity[1]
                    }
                  </SpSelectMenuItem>
                </SpSelect>
              </Grid>
              {renderDateDisponibility()}
            </Grid>

            <Grid
              id={"scrollingDivAvailability"}
              ref={scrollingDivAvailability}
              item
              xs={10}
              container
              direction="row"
              wrap={"nowrap"}
              className={classes.root}
              style={{
                height: "100%",
                overflowX: "scroll",
                maxWidth: 1200,
              }}
            >
              {renderColumnDisponibility()}
            </Grid>
          </Grid>
        </div>
      )}

      <ChangeAvailabilityDialog
        openToggleAvailability={openToggleAvailability}
        setOpenToggleAvailability={setOpenToggleAvailability}
        availabilitySelected={availabilitySelected}
        updateEvent={async () => {
          await fetchDataSituationTable();
        }}
      />
    </Grid>
  );
};
